<form [formGroup]="formGroup" (ngSubmit)="submitForm()" [class]="classLayout">
    @for (item of items; track item.key) {
        @switch (item.field.type) {
            @case (DynamicFormControlTypeEnum.Text) {
                <arc-input
                    class="mb-4"
                    [control]="item.control"
                    [placeholder]="item.field.label"
                    type="text"
                    [label]="item.field.isLabelTranslated ? item.field.label : ''"
                    [labelKey]="!item.field.isLabelTranslated ? item.field.label : ''" />
            }
            @case (DynamicFormControlTypeEnum.Textarea) {
                <arc-textarea
                    class="mb-4"
                    [formControl]="item.control | formControl"
                    [placeholder]="item.field.label"
                    [label]="item.field.label"
                    [isLabelTranslated]="item.field.isLabelTranslated" />
            }
            @case (DynamicFormControlTypeEnum.Label) {
                <div class="ml-4">
                    <span>{{ item.field.isLabelTranslated ? item.field.label : (item.field.label | transloco) }}</span>
                </div>
            }
            @case (DynamicFormControlTypeEnum.Number) {
                <arc-number-input
                    class="mb-4"
                    [formControl]="item.control | formControl"
                    [decimalPlaces]="0"
                    [placeholder]="item.field.label"
                    [label]="item.field.label"
                    [isLabelTranslated]="item.field.isLabelTranslated" />
            }
            @case (DynamicFormControlTypeEnum.Decimal) {
                <arc-number-input
                    class="mb-4"
                    [formControl]="item.control | formControl"
                    [decimalPlaces]="GlobalConstants.maxDecimalPlaces"
                    [placeholder]="item.field.label"
                    [label]="item.field.label"
                    [isLabelTranslated]="item.field.isLabelTranslated" />
            }
            @case (DynamicFormControlTypeEnum.Checkbox) {
                <arc-checkbox
                    [control]="item.control"
                    [placeholder]="item.field.label"
                    [label]="item.field.label"
                    [label]="item.field.isLabelTranslated ? item.field.label : ''"
                    [labelKey]="!item.field.isLabelTranslated ? item.field.label : ''" />
            }
            @case (DynamicFormControlTypeEnum.Date) {
                <div class="mb-4">
                    <arc-datepicker
                        [control]="item.control"
                        [label]="item.field.label"
                        [label]="item.field.isLabelTranslated ? item.field.label : ''"
                        [labelKey]="!item.field.isLabelTranslated ? item.field.label : ''" />
                </div>
            }
            @case (DynamicFormControlTypeEnum.DateTime) {
                <div class="mb-4">
                    <arc-datetime-picker
                        [control]="item.control"
                        [label]="item.field.label"
                        [label]="item.field.isLabelTranslated ? item.field.label : ''"
                        [labelKey]="!item.field.isLabelTranslated ? item.field.label : ''" />
                </div>
            }
            @case (DynamicFormControlTypeEnum.DateRange) {
                <div class="mb-4">
                    <arc-date-range-picker
                        [control]="asFormGroup(item.control).controls['FromDate']"
                        [controlEnd]="asFormGroup(item.control).controls['ToDate']"
                        [label]="item.field.label"
                        [label]="item.field.isLabelTranslated ? item.field.label : ''"
                        [labelKey]="!item.field.isLabelTranslated ? item.field.label : ''" />
                </div>
            }
            @case (DynamicFormControlTypeEnum.ButtonToggle) {
                <div class="mb-4">
                    <section>
                        @if (!!item.field.label) {
                            <span>{{ item.field.label }}</span>
                        }
                        <arc-button-toggle-group [control]="item.control | formControl" [items]="item.field.selectOptions!" />
                    </section>
                </div>
            }
            @case (DynamicFormControlTypeEnum.Select) {
                <arc-select
                    class="mb-4"
                    [control]="item.control"
                    [options]="item.field.selectOptions!"
                    [isMultiselect]="item.field.isMultiselect"
                    [label]="item.field.isLabelTranslated ? item.field.label : ''"
                    [labelKey]="!item.field.isLabelTranslated ? item.field.label : ''" />
            }
            @case (DynamicFormControlTypeEnum.GeneralData) {
                <arc-general-data-select
                    class="mb-4"
                    [formControl]="item.control | formControl"
                    [isMultiselect]="item.field.isMultiselect"
                    [generalDataType]="item.field.generalDataType!"
                    [label]="item.field.label"
                    [isLabelTranslated]="item.field.isLabelTranslated" />
            }
            @case (DynamicFormControlTypeEnum.Markdown) {
                <arc-markdown-editor class="mb-4" [formControl]="item.control | formControl" />
            }
            @case (DynamicFormControlTypeEnum.PortalResellers) {
                <arc-quick-search
                    class="mb-4"
                    [formControl]="item.control | formControl"
                    [config]="ComplexDataTypesEnum.Reseller | arcQuickSearchConfig" />
            }
            @case (DynamicFormControlTypeEnum.PortalLicenses) {
                <arc-quick-search
                    class="mb-4"
                    [formControl]="item.control | formControl"
                    [config]="ComplexDataTypesEnum.License | arcQuickSearchConfig" />
            }
            @case (DynamicFormControlTypeEnum.PortalUsers) {
                <arc-quick-search
                    class="mb-4"
                    [formControl]="item.control | formControl"
                    [config]="ComplexDataTypesEnum.User | arcQuickSearchConfig" />
            }
            @case (DynamicFormControlTypeEnum.PortalIndustries) {
                <arc-quick-search
                    class="mb-4"
                    [label]="item.field.label"
                    [formControl]="item.control | formControl"
                    [config]="ComplexDataTypesEnum.Industry | arcQuickSearchConfig" />
            }
            @default {
                <arc-input
                    class="mb-4"
                    [control]="item.control"
                    [placeholder]="item.field.label"
                    type="text"
                    [label]="item.field.isLabelTranslated ? item.field.label : ''"
                    [labelKey]="!item.field.isLabelTranslated ? item.field.label : ''" />
            }
        }
    }
</form>
